const SAMPLE_RATE = import.meta.env.PROD ? 0.1 : 1;

const hashEmail = (email) => {
  if (!email || typeof email !== 'string') return undefined;
  const normalized = email.trim().toLowerCase();
  let hash = 0;
  for (let i = 0; i < normalized.length; i += 1) {
    hash = (hash << 5) - hash + normalized.charCodeAt(i);
    hash |= 0;
  }
  return `e_${Math.abs(hash)}`;
};

export const flowLogger = (event, payload = {}) => {
  if (import.meta.env.PROD && Math.random() > SAMPLE_RATE) {
    return;
  }

  const entry = {
    event,
    ts: new Date().toISOString(),
    ...payload,
  };

  if (entry.email) {
    entry.emailHash = hashEmail(entry.email);
    delete entry.email;
  }

  if (import.meta.env.DEV) {
    console.info('[flow]', entry);
  } else {
    console.log(JSON.stringify({ source: 'baoubab-fe', ...entry }));
  }

  if (typeof window !== 'undefined' && import.meta.env.VITE_API_URL) {
    const body = JSON.stringify({ source: 'baoubab-fe', ...entry });
    try {
      if (navigator.sendBeacon) {
        const blob = new Blob([body], { type: 'application/json' });
        navigator.sendBeacon(`${import.meta.env.VITE_API_URL}/api/client-events`, blob);
      }
    } catch {
      // Non-blocking diagnostic
    }
  }
};
